import React from "react";
import { useTranslation } from "react-i18next";

const AppUpperSection = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="app-links-container">
        <a
          className="app-badge"
          href="https://products.aspose.ai/total/paraphraser/"
        >
          {t("app.navLinks.paraphraser")}
        </a>
        <a className="app-badge" href="https://products.aspose.ai/total/chat/">
          {t("app.navLinks.documentChat")}
        </a>
        <a
          className="app-badge"
          href="https://products.aspose.ai/total/powerpoint-summarizer/"
        >
          {t("app.navLinks.powerpointSummarizer")}
        </a>
        <a
          className="app-badge"
          href="https://products.aspose.ai/total/readabilitychecker/"
        >
          {t("app.navLinks.readabilityChecker")}
        </a>
        <a
          className="app-badge"
          href="https://products.aspose.ai/total/text-moderation/"
        >
          {t("app.navLinks.contentModeration")}
        </a>
        <a
          className="app-badge"
          href="https://products.aspose.ai/total/speech-to-text/"
        >
          {t("app.navLinks.speechToText")}
        </a>
        <a
          className="app-badge"
          href="https://products.aspose.ai/total/speech-summarizer/"
        >
          {t("app.navLinks.speechSummarizer")}
        </a>
        <a
          className="app-badge"
          href="https://products.aspose.ai/total/ai-quiz-maker/"
        >
          {t("app.navLinks.aiQuizMaker")}
        </a>
      </div>

      <header className="app-header">
        <h1>{t("app.header.title")}</h1>
        <p>{t("app.header.description")}</p>
        <p className="powered-by">
          {t("app.header.poweredBy")}{" "}
          <a href="https://aspose.com/">aspose.com</a>,{" "}
          <a href="https://aspose.net/">aspose.net</a> {t("app.legal.and")}{" "}
          <a href="https://aspose.cloud/">aspose.cloud</a>.
        </p>
      </header>
    </div>
  );
};

export default AppUpperSection;
